import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Label } from 'reactstrap';
import Toggle from '../../Toggle';
import EditAtaNumber from './EditAtaNumber';

const EditAtaNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  boxDetails,
  selectRoute,
  gateways,
  onRemoveNumber,
  type,
  user,
  vmail,
}) => {
  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="edit-number-port">
        Edit ATA Number
        <Row>
          <Label for="enabled" sm={4}>
            Assign New Number
          </Label>
          <Col sm={3} style={{ marginTop: '8px' }}>
            <Toggle value={false} />
          </Col>
          <Label for="enabled" sm={4}>
            Port Number
          </Label>
        </Row>
      </ModalHeader>
      <ModalBody>
        <EditAtaNumber
          vmail={vmail}
          toggleMode
          onRemoveNumber={onRemoveNumber}
          selectRoute={selectRoute}
          gateways={gateways}
          boxDetails={boxDetails}
        />
      </ModalBody>
      <ModalFooter>
        {(user.role === 'superAdmin' ||
          user.role === 'companyGroupAdmin' ||
          user.role === 'supportEngineer' ||
          (user.role === 'admin' && type === 'dialout') ||
          (user.role === 'enterpriseAdmin' && type === 'dialout'))
         ? (
          <>
            <Button color="secondary" outline onClick={onCancel}>
              Cancel
            </Button>{' '}
            <Button color="primary" onClick={onConfirm}>
              Save
            </Button>
          </>
        ) : (
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.editNumber.company,
  type: state.UIState.numbers.editNumber.type,
  user: state.AppState.user,
});

export default connect(
  mapStateToProps,
  null,
)(EditAtaNumberModal);
